import React from 'react'
import { TextField, BooleanField } from 'react-admin'
import { ListGuesser } from 'theme/components'

export const CustomerSourceStoreList = (props) => (
  <ListGuesser
    {...props}
    filter={{
      properties: ['id', 'name', 'enabledInPortal', 'slug'],
      'properties[store]': ['name'],
      'properties[customerSource]': ['name'],
    }}
    rowClick="edit"
  >
    <TextField
      source="originId"
      label="id"
      sortBy="id"
      sort={{ field: 'id', order: 'DESC' }}
    />
    <TextField source="customerSource.name" label="Customer source" />
    <TextField source="name" label="Translated customer source" />
    <TextField source="store.name" label="Store" />
    <BooleanField source="enabledInPortal" />
  </ListGuesser>
)
